import { useTranslation } from 'react-i18next';

import { PollSlideTypes } from '../../../../../../db/types';
import { i18nNS } from '../../../../../../i18n';
import BarGraphIcon from '../../../../../../icons/BarGraphIcon';
import PieChartIcon from '../../../../../../icons/PieChartIcon';
import { IconNamePair } from './styles';
import useSlideIdentifier from './vm';

const SlideIdentifier = () => {
  const { t } = useTranslation();

  const { slideType } = useSlideIdentifier();

  switch (slideType) {
    case PollSlideTypes.BAR_GRAPH:
      return <IconNamePair icon={BarGraphIcon}>{t('bar_graph', { ns: i18nNS.POLL })}</IconNamePair>;
    case PollSlideTypes.PIE_CHART:
      return <IconNamePair icon={PieChartIcon}>{t('pie_chart', { ns: i18nNS.POLL })}</IconNamePair>;
    default:
      return null;
  }
};

export default SlideIdentifier;
